export default {
  name: 'Name',
  status: 'Status',
  description: 'Description',
  source: {
    type: 'Source type'
  },
  output: {
    type: 'Output type'
  },
  pipeline: {
    name: 'Pipeline name'
  },
  progress: 'Progress',
  created_by: 'Created by',
  created_time: 'Created time',
  modified_time: 'Modified time',
  origin_time: "Origin time",
  element_name: 'Element name',
  element_type: 'Element type',
  access: 'Access',
  usage: 'Used by dashboards',
  list_type: 'List type',
  list_last_update: 'Last update',
  number_of_items: 'Number of items',
  ID: 'ID',
  image_1: 'Image 1',
  image_2: 'Image 2'
}
